import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FloorSignage = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 16C13.346 16 12 14.654 12 13C12 11.346 13.346 10 15 10C16.654 10 18 11.346 18 13C18 14.654 16.654 16 15 16ZM15 12C14.449 12 14 12.449 14 13C14 13.551 14.449 14 15 14C15.551 14 16 13.551 16 13C16 12.449 15.551 12 15 12Z" />
		<path d="M27.983 26.821L23.983 4.821C23.899 4.354 23.491 4 23 4H11C10.549 4 10.154 4.302 10.035 4.737L4.036 26.737C4.013 26.821 4 26.909 4 27C4 27.552 4.448 28 5 28C5.461 28 5.848 27.687 5.964 27.263L6.855 24H16.782L16.036 26.737C16.013 26.821 16 26.909 16 27C16 27.552 16.448 28 17 28C17.461 28 17.848 27.687 17.964 27.263L19.946 20H24.711L26.017 27.179C26.101 27.646 26.509 28 27 28C27.552 28 28 27.552 28 27C28 26.939 27.994 26.879 27.983 26.821V26.821ZM17.327 22H7.4L11.764 6H21.691L17.327 22ZM20.491 18L22.805 9.516L24.348 18H20.492H20.491Z" />
	</svg>
);

export default FloorSignage;
